import { MyCampApp } from '../common/enumerations';

import { NotificationSendInfo } from './notification-send-info.model';
import NotificationType = MyCampApp.NotificationType;
import RegistrationFilterType = MyCampApp.RegistrationFilterType;

export class NotificationItem
{
    static TitleMaxLength = 150;
    static EmailTextMaxLength = 20000;
    static PushTextMaxLength = 250;
    static SmsTextMaxLength = 160;
    static MIN_DEFAULT_NOTIFICATION_HOUR = 7;

    Id = 0;
    SendInfos: NotificationSendInfo[] = [];
    CategoryIds: number[] = [];
    RegistrationFilter = RegistrationFilterType.All;
    Type = NotificationType.Push;
    Title = '';
    Text = '';
    HtmlText = '';
    MediaUrl?: string; // This only has a value if the notification has already been saved (see the PhotoFile property)
    PdfUrl?: string; // This only has a value if the notification has already been saved (see the PdfFile property)
    PhotoFile?: File; // Contains File to upload - MediaUrl during the save process
    PdfFile?: File; // Contains File to upload - PdfUrl during the save process
    Sound?: string;
    IsAssociatedWithContentItem = false;
    IsCampSiteCreated = false;
    NumCampSiteMembers = 0;

    constructor(json: any = null)
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);

            // Custom mappings
            this.SendInfos = json.SendInfos.map((item: any) => new NotificationSendInfo(item))
                .sort((a: NotificationSendInfo, b: NotificationSendInfo) => a.ScheduledDateTimeUTC! > b.ScheduledDateTimeUTC! ? 1 : -1);

            // Eliminate stuff we don't want
            // @ts-ignore
            delete this['OrganizationId'];
        }
    }

    get IsPublished(): boolean { return this.SendInfos.some(si => si.SentDateTime != null); }

    get AllSent(): boolean { return this.SendInfos.every(si => si.SentDateTime != null); }

    static createCopy(item: NotificationItem)
    {
        const copy = new NotificationItem();
        Object.assign(copy, item);
        return copy;
    }

    static typeFromString(str: string): NotificationType
    {
        return str.toString() === '1' ? NotificationType.Email : str.toString() === '2' ? NotificationType.Push : NotificationType.Sms;
    }
}
